import type { FC } from "react"
import React from "react"

import { useRecoilValue, useSetRecoilState } from "recoil"
import styled from "styled-components"

import { designIdState } from "~/containers/Proposal/state/designs/design-state"
import { proposalRemoteState } from "~/containers/Proposal/state/proposal/proposal-state"

import { ReactComponent as FolderIcon } from "@svg/folder.svg"

import { showDesignSwitcherState } from "."

const Button = styled.button`
  border: 1px solid #d6e1f0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  border-radius: 5px;
  width: fit-content;
  padding: 0 10px;
  gap: var(--space-s);
  cursor: pointer;
  p {
    font-size: var(--step--1);
    font-weight: 500;
    color: var(--blue-dark-font);
    white-space: nowrap;
  }
`

const VersionIcon_Internal: FC = () => {
  const setShow = useSetRecoilState(showDesignSwitcherState)
  const proposal = useRecoilValue(proposalRemoteState)
  const designId = useRecoilValue(designIdState)
  const sorted = [...proposal.designs].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  )

  const indexInArray = sorted.findIndex((d) => d.id === designId)
  const index = indexInArray === -1 ? 0 : indexInArray + 1

  return (
    <Button title="Design Versions" onClick={() => setShow(true)}>
      <p>Ver. {index < 10 ? `0${index}` : index}</p>
      <FolderIcon />
    </Button>
  )
}

export const VersionIcon = React.memo(VersionIcon_Internal)
